import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { useObservable } from "@faire/web--source/ui/hooks/useObservable";
import { useCallback, useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
// percentage of user session that will trigger image viewing event
var SAMPLE_RATE = 1;
var SHOULD_TRACK = Math.random() * 100 < SAMPLE_RATE;
var PRODUCT_IMAGE_GALLERY_TOKEN = "productImageGallery";
export var useImageGalleryHandler = function() {
    var _useState = _sliced_to_array(useState(false), 2), isImageGalleryOpen = _useState[0], setIsImageGalleryOpen = _useState[1];
    var history = useHistory();
    var location = useLocation();
    var closedByBackButton = useRef(false);
    var isLocationStateGalleryOpened = location.state === PRODUCT_IMAGE_GALLERY_TOKEN;
    var openImageGallery = useCallback(function() {
        if (!isImageGalleryOpen) {
            history.push(_object_spread_props(_object_spread({}, location), {
                state: PRODUCT_IMAGE_GALLERY_TOKEN
            }));
        }
        setIsImageGalleryOpen(true);
        closedByBackButton.current = false; // reset the flag when we open the gallery
    }, [
        isImageGalleryOpen,
        history,
        location
    ]);
    var closeImageGallery = useCallback(function() {
        if (isImageGalleryOpen && !closedByBackButton.current) {
            history.goBack();
        }
        setIsImageGalleryOpen(false);
        closedByBackButton.current = false; // reset the flag when we close the gallery
    }, [
        closedByBackButton,
        history,
        isImageGalleryOpen
    ]);
    // listen to browser back button event to close the modal in this case:
    useEffect(function() {
        var _getWindow;
        var handlePopState = function() {
            // Indicate that the gallery is being closed by the back button
            closedByBackButton.current = true;
            closeImageGallery();
        };
        (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.addEventListener("popstate", handlePopState);
        return function() {
            var _getWindow;
            (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.removeEventListener("popstate", handlePopState);
        };
    }, [
        closeImageGallery
    ]);
    return {
        openImageGallery: openImageGallery,
        closeImageGallery: closeImageGallery,
        isImageGalleryOpen: isImageGalleryOpen || isLocationStateGalleryOpened
    };
};
export var useTrackImageChangeProductEvent = function(state, token) {
    var imageChangeProductEventPrefix = state.selectedImage ? "product/".concat(token, "/image/").concat(state.selectedImage.token) : null;
    var selectedImage = useObservable(function() {
        return state.selectedImage;
    });
    var images = useObservable(function() {
        return state.images;
    });
    var hasSentTrackEventDefaultRef = useRef(false);
    useEffect(function() {
        if (images.length > 0 && selectedImage && !hasSentTrackEventDefaultRef.current && SHOULD_TRACK && imageChangeProductEventPrefix) {
            trackEvent("".concat(imageChangeProductEventPrefix, "/default"));
            hasSentTrackEventDefaultRef.current = true;
        }
    }, [
        imageChangeProductEventPrefix,
        images.length,
        selectedImage
    ]);
    useEffect(function() {
        if (SHOULD_TRACK) {
            if (imageChangeProductEventPrefix) {
                trackEvent("".concat(imageChangeProductEventPrefix, "/change"));
            }
        }
    }, [
        imageChangeProductEventPrefix
    ]);
};
